module.exports = __webpack_public_path__ + "img/f08da072d6b2b47ce99bc0314459b4af.1a345912.png";